import "../../styles/profile.scss";

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { setBackgroundImage } from "../../helpers/helpers";
import { useAuth } from "../../hooks/AuthContext";

import History from "./History";

const DEFAULT_PAGE = "history";

const Account = () => {
    const { authUser } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    setBackgroundImage('');

    const joinDate = authUser?.metadata.creationTime ? new Date(authUser.metadata.creationTime) : new Date();

    useEffect(() => {
        if (!location.hash) {
            navigate(`#${DEFAULT_PAGE}`, { replace: true });
        }
    }, [location, navigate]);

    const page = location.hash.replace("#", "") || DEFAULT_PAGE;

    return (    
        <>
            <div className="profile-container">
                <h1>{authUser?.displayName || authUser?.email}</h1>
                <h2>Member since {format(joinDate, 'dd MMM yyyy hh:mm a')}</h2>
                <nav className="profile-nav">
                    <ul>
                        <li className={page === "history" ? "active" : ""} onClick={() => navigate("#history")}>History</li>
                    </ul>
                </nav>

                <div className="profile-content">
                    {page === "history" && <History />}
                </div>
            </div>


        </>
    );
};

export default Account;
